<template>
<body id="page-top" class="body-bg">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio certificate-login-section" id="portfolio">
            <div class="container">
              <form autocomplete="off" @submit.prevent="handleSubmit">
                <div class="login-form">
                  <div v-if="step === 1">
                <p class="h4">WHAT IS YOUR NAME?</p>
                <div class="mb-3 row">
                    <label for="exampleFormControlTextarea1" class="col-sm-2 col-form-label">First Name*</label>
                    <div class="col-sm-10">
                      <input autocomplete="off" v-model="firstName" type="text" class="form-control" id="exampleFormControlTextarea1" @focus="show" data-layout="normal" required>
                      <p style="font-size: 16px !important;">ex: Nicolas Joseph</p>
                    </div>
               </div>
               <!--<div class="mb-3 row">
                    <label for="exampleFormControlTextarea1" class="col-sm-2 col-form-label">Middle Initial*</label>
                    <div class="col-sm-10">
                      <input autocomplete="off" v-model="middleName" type="text" class="form-control middle-initial" id="exampleFormControlTextarea1" @focus="show" data-layout="normal" required>
                      <p style="font-size: 16px !important;">ex: P</p>
                    </div>
               </div>-->
               <div class="mb-3 row">
                <label for="exampleFormControlTextarea1" class="col-sm-2 col-form-label">Last Name*</label>
                <div class="col-sm-10">
                  <input autocomplete="off" v-model="lastName" type="text" class="form-control" id="exampleFormControlTextarea1" @focus="show" data-layout="normal" required>
                  <p style="font-size: 16px !important;">ex: Tangalin Jr.</p>
                </div>
               </div>
           
            
                <div class="mb-3 row">
                    <label for="exampleFormControlTextarea1" class="col-sm-2 col-form-label">Birthdate*</label>
                    <div class="col-sm-10">
                      <input v-model="birthDate" name="birthDate" autocomplete="off" @focus="show" data-layout="numeric" type="text"  id="phone" placeholder="mm/dd/yyyy" v-mask="'##/##/####'" class="form-control">
                      <p style="font-size: 16px !important;">ex: MM/DD/YYYY</p>
                    </div>
                  </div>
            </div>
        </div>

               <div class="col-md-12">
                  <router-link to="/options-login"><button style="float:left" type="button" class="btn btn-primary btn-lg" >CANCEL</button></router-link>
                  <button class="btn btn-primary btn-lg">SUBMIT</button>
            </div>
            </form>
             </div> 

              <div>
                <b-modal content-class="customer-adv-modal" centered title="" ref="my-modal" id="modal-center2">
                    <p class="my-4">{{returnMessage}}</p>
                  </b-modal>
                  <b-modal content-class="customer-adv-modal" centered title="" ref="my-modal2" id="modal-center" hide-header-close="true" no-close-on-esc="true" no-close-on-backdrop="true" >
                    <p class="my-4">{{returnMessage}}</p>
                    <button class="btn btn-primary btn-lg" @click="hideModal2">EXIT</button>
                  </b-modal>
              </div>

        </section>
        
</body>
</template>

<script>
import axios from 'axios';
export default {
  name: 'PhilLogin',
  data() {
    return {
      firstName: '',
      middleName: '',
      lastName: '',
      birthDate:'',
      certNo: '',
      returnMessage:'',
      step: 1,
      visible: false,
        layout: "normal",
        input: null,
        options: {
        useKbEvents: false,
        preventClickEvent: false
    },
    memberFPS : true
    }
  },
  methods: {
    
    previousStep(){
      this.step = this.step-1
    },
    nextStep(){
      this.step = this.step+1
      console.log('STEP', this.step);
    },
    async handleSubmit() {
      console.log(this.step);
      if (this.step == 1){
        if (this.birthDate != " "){
              const response = await axios.post('/api/?action=member-login', {
                FirstName: this.firstName,
                MiddleInitial: this.middleName,
                LastName: this.lastName,
                BirthDate: this.birthDate
              }, 
            );
            console.log("personal", response);
            if (response.data.SuccessFlag == 'True'){
               this.memberFPS = response.data.memberFPS
               localStorage.setItem('TokenID', response.data.TokenID)
               localStorage.setItem('CertNo', response.data.CertNo)
                this.returnMessage = response.data.MessageReturn
                this.showModal()
                setTimeout(() => this.$router.push('/member-page'), 800);
            } else {
                this.showModal2()
                this.returnMessage = response.data.MessageReturn
                //this.showModal()
                console.log(this.returnMessage);
            }
            console.log(response);
        }
      }
        //this.$router.push('/birth-date');
        //if (this.step < 2) {
        // this.nextStep()
         //}
    },
    showModal() {
            this.$refs['my-modal'].show()
          },
    showModal2() {
      this.$refs['my-modal2'].show()
    },
    hideModal2() {
      this.$refs['my-modal2'].hide()
      this.$router.push('/login')
    },
    accept() {
          this.hide();
        },
 
        show(e) {
          this.input = e.target;
          this.layout = e.target.dataset.layout;
 
          if (!this.visible)
            this.visible = true
        },
 
        hide() {
          this.visible = false;
          console.log(document.querySelector(":focus"));
        },
  }
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
